import { useMutation, useQueryClient } from "react-query";
import { Delete } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { Cart } from "../../types/api/Cart";

export default (
  lineItemId: string,
  sellerOrgId: string,
  buyerOrgId: string
) => {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();
  return useMutation<Cart, null, string>(
    async () =>
      Delete(
        `/api/cart/line_item/${lineItemId}`,
        await getAccessTokenSilently()
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          `current_cart_${sellerOrgId}_${buyerOrgId}`,
        ]);
      },
    }
  );
};
